import AXIOS from '@/axios-instance';

export default {
  retrieveHistory(uuidModel) {
    return AXIOS.get("/bpmn/" + uuidModel + "/history");
  },
  getHistoryProcessXml(uuidModel, commit) {
    return AXIOS.get(
      "/bpmn/" + uuidModel + "/history/commit/" + commit
    );
  },
  revertToHistoryVersion(uuidModel, commit) {
    return AXIOS.put(
      "/bpmn/" + uuidModel + "/history/commit/" + commit
    );
  },
};
